import React from "react";
import { useTranslation } from "react-i18next";
import localizationKeys from "../../../../i18n/localizationKeys.js";
import * as PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import constants from "../../utils/constants.js";
import DurationCalendar from "./durationCalendar.jsx";

const RecoveryFilter = ({ disabled = false, classes, minDate }) => {
  const { t } = useTranslation();
  return (
    <Box sx={classes.itemForSearchDate}>
      <Typography
        variant="body2"
        sx={{
          ...(disabled ? classes.disableColumnName : classes.columnName),
          ...classes.recoveryColumn,
          color: '#28b6c7'
        }}
      >
        {t(localizationKeys.RecoveryTime_lower)}
      </Typography>
      <DurationCalendar
        minDate={minDate}
        disabled={disabled}
        type={constants.DURATION_TYPE.RECOVERY}
      />
    </Box>
  );
};

RecoveryFilter.propTypes = {
  disabled: PropTypes.bool,
  classes: PropTypes.object,
  minDate: PropTypes.object,
};

export default RecoveryFilter;
